import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { DEPRECATED_Typography } from "../DEPRECATED_Typography";
import styles from "./TierPointsProgressBar.module.scss";
export const TierPointsProgressBar = ({ currentPoints, pointsForBlackTier, tier, pointsForGoldTier, pointsLabel = "0", pointsTitle, pointsFooter, }) => {
    const getPositionInPercent = (maxPoints, valueToCheck) => {
        const progress = parseFloat(((valueToCheck / maxPoints) * 100).toFixed(0));
        return progress >= 100 ? 100 : progress;
    };
    const [withPointsOutside, setWithPointsOutside] = useState(false);
    const currentProgress = getPositionInPercent(pointsForBlackTier, currentPoints);
    const pointsOnProgressBar = currentProgress === 100 ? `${pointsForBlackTier}+` : currentPoints;
    const progressBarRef = useRef(null);
    const pointsRef = useRef(null);
    const userTier = tier.toLowerCase();
    const progressBarClasses = classNames(styles.progressBar, {
        [styles.silver]: userTier === "silver",
        [styles.gold]: userTier === "gold",
        [styles.black]: userTier === "black",
    });
    const checkForFontColorWithBlackTier = () => {
        if (withPointsOutside && userTier === "black")
            return "black";
        return userTier === "black" ? "white" : "black";
    };
    useEffect(() => {
        const progressBar = progressBarRef.current;
        const progressText = pointsRef.current;
        const progressBarWidth = progressBar.offsetWidth;
        const progressTextWidth = progressText.offsetWidth;
        if (progressTextWidth + 20 > progressBarWidth * (currentPoints / pointsForBlackTier)) {
            setWithPointsOutside(true);
        }
        else {
            setWithPointsOutside(false);
        }
    }, [currentPoints, pointsForBlackTier]);
    return (_jsxs("div", { className: styles.tierPointsProgressBar, children: [_jsx(DEPRECATED_Typography, { className: styles.pointsTitle, type: "p1", color: "black", children: pointsTitle }), _jsxs("div", { className: styles.pointsWrapper, children: [_jsxs("div", { className: styles.pointsLabels, children: [_jsx(DEPRECATED_Typography, { className: styles.label, color: "black", weight: "bold", children: pointsLabel }), _jsx("div", { className: styles.goldTierLabelWrapper, style: { insetInlineStart: `${getPositionInPercent(pointsForBlackTier, pointsForGoldTier)}%` }, children: _jsx(DEPRECATED_Typography, { className: styles.label, color: "black", weight: "bold", children: pointsForGoldTier }) }), _jsx(DEPRECATED_Typography, { className: styles.label, color: "black", weight: "bold", children: pointsForBlackTier })] }), _jsx("div", { ref: progressBarRef, "data-testid": "progress-bar", className: progressBarClasses, style: {
                            "--progress": `${currentProgress}%`,
                        }, children: _jsx(DEPRECATED_Typography, { ref: pointsRef, className: classNames(styles.pointsInside, {
                                [styles.fullProgress]: currentProgress === 100,
                                [styles.pointsOutside]: withPointsOutside,
                            }), color: checkForFontColorWithBlackTier(), weight: "bold", children: `${pointsOnProgressBar}` }) })] }), _jsx(DEPRECATED_Typography, { className: styles.pointsFooter, color: "black", children: pointsFooter })] }));
};
//# sourceMappingURL=TierPointsProgressBar.js.map